import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('search', [
  'FETCH_STATS',
  'FETCH_STATS_SUCCESS',
  'FETCH_STATS_FAILURE',

  'FETCH_SUBJECT_COVERAGE',
  'FETCH_SUBJECT_COVERAGE_SUCCESS',
  'FETCH_SUBJECT_COVERAGE_FAILURE'
])

export const fetchStats = () => ({
  type: constants.FETCH_STATS
})

export const fetchSubjectCoverage = () => ({
  type: constants.FETCH_SUBJECT_COVERAGE
})
